<template>
  <v-container>
    <v-snackbar v-model="snackbar.model" top :color="snackbar.color">
      {{ snackbar.detail }}
    </v-snackbar>
    <ProdServiceDetail ref="itemDetail"
      @close-detail="onDetailClosed"
      @show-message="onMessageDisplay"
    />
    <v-row>
      <v-col cols="12">
        <v-btn small rounded color="success" class="mb-2" @click="showEmptyDetail">
          <v-icon>add</v-icon> Add Product/Service
        </v-btn>
      </v-col>
      <v-col class="entity-list">
        <ProdServiceList @load-detail="loadDetail" ref="itemList"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import ProdServiceList from './list'
import ProdServiceDetail from './detail'

@Component({
  components: {
    ProdServiceList,
    ProdServiceDetail
  }
})
export default class ProdService extends Vue {
  entityId = null
  snackbar = { model: false }

  loadDetail (item) {
    this.$nextTick(() => {
      this.$refs.itemDetail.load(item.id)
    })
  }

  load (entityId) {
    this.entityId = entityId
    return this.$refs.itemList.load(entityId)
  }

  closeDetail () {
    this.$refs.itemDetail.close()
  }

  showEmptyDetail () {
    this.$nextTick(() => {
      this.$refs.itemDetail.open(this.entityId)
    })
  }

  onDetailClosed () {
    this.$refs.itemList.load(this.entityId)
  }

  onMessageDisplay (data) {
    this.snackbar = {
      model: true,
      detail: data.message + (data.error !== undefined ? `: ${data.error}` : ''),
      color: data.error === undefined ? 'success' : 'error'
    }
  }
}
</script>

<style lang="scss">
.active-account {
  border-left: 2px solid blue;
}
.entity-list {
  transition: width .3s, max-width .3s !important;
}
.account-detail {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
</style>
